import { Pipe, PipeTransform } from '@angular/core';
import { isObject } from 'util';

@Pipe({
  name: 'typeNotation'
})
export class TypeNotationPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!isObject(value)) {
      return '';
    }
    return value['libelle'] ? value['libelle'] : '';
  }

}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/pipes/type-notation.pipe.ts